import { figmaColors } from '@doltech/ui/lib/figma/colors';
import { types as t } from 'mobx-state-tree';

export const MarkHighlightMultipleColor = t.model('MarkHighlightMultipleColor', {
  uuid: t.string,
  color: t.optional<any>(t.string, figmaColors.primary5),
});

